// Generated by paradox-phoenix — do not edit

export const TimeZone = {
  utc: "utc",
  america_new_york: "americaNewYork",
  america_chicago: "americaChicago",
  america_denver: "americaDenver",
  america_los_angeles: "americaLosAngeles",
  america_anchorage: "americaAnchorage",
  america_honolulu: "americaHonolulu",
  america_phoenix: "americaPhoenix",
  america_toronto: "americaToronto",
  america_vancouver: "americaVancouver",
  america_mexico_city: "americaMexicoCity",
  america_sao_paulo: "americaSaoPaulo",
  america_argentina_buenos_aires: "americaArgentinaBuenosAires",
  america_bogota: "americaBogota",
  america_lima: "americaLima",
  america_santiago: "americaSantiago",
  europe_london: "europeLondon",
  europe_paris: "europeParis",
  europe_berlin: "europeBerlin",
  europe_amsterdam: "europeAmsterdam",
  europe_madrid: "europeMadrid",
  europe_rome: "europeRome",
  europe_moscow: "europeMoscow",
  europe_istanbul: "europeIstanbul",
  europe_warsaw: "europeWarsaw",
  europe_zurich: "europeZurich",
  asia_tokyo: "asiaTokyo",
  asia_shanghai: "asiaShanghai",
  asia_hong_kong: "asiaHongKong",
  asia_seoul: "asiaSeoul",
  asia_singapore: "asiaSingapore",
  asia_dubai: "asiaDubai",
  asia_kolkata: "asiaKolkata",
  asia_bangkok: "asiaBangkok",
  asia_jakarta: "asiaJakarta",
  asia_taipei: "asiaTaipei",
  australia_sydney: "australiaSydney",
  australia_melbourne: "australiaMelbourne",
  pacific_auckland: "pacificAuckland",
  africa_cairo: "africaCairo",
  africa_lagos: "africaLagos",
  africa_johannesburg: "africaJohannesburg",
  africa_nairobi: "africaNairobi",
} as const;

export type TimeZone =
  | "utc"
  | "americaNewYork"
  | "americaChicago"
  | "americaDenver"
  | "americaLosAngeles"
  | "americaAnchorage"
  | "americaHonolulu"
  | "americaPhoenix"
  | "americaToronto"
  | "americaVancouver"
  | "americaMexicoCity"
  | "americaSaoPaulo"
  | "americaArgentinaBuenosAires"
  | "americaBogota"
  | "americaLima"
  | "americaSantiago"
  | "europeLondon"
  | "europeParis"
  | "europeBerlin"
  | "europeAmsterdam"
  | "europeMadrid"
  | "europeRome"
  | "europeMoscow"
  | "europeIstanbul"
  | "europeWarsaw"
  | "europeZurich"
  | "asiaTokyo"
  | "asiaShanghai"
  | "asiaHongKong"
  | "asiaSeoul"
  | "asiaSingapore"
  | "asiaDubai"
  | "asiaKolkata"
  | "asiaBangkok"
  | "asiaJakarta"
  | "asiaTaipei"
  | "australiaSydney"
  | "australiaMelbourne"
  | "pacificAuckland"
  | "africaCairo"
  | "africaLagos"
  | "africaJohannesburg"
  | "africaNairobi";


export const TargetLanguage = {
  typescript: "TypeScript",
  haskell: "Haskell",
  sqlite: "SQLite",
  postgresql: "PostgreSQL",
  bash_lang: "Bash",
  rust: "Rust",
  elixir: "Elixir",
  python: "Python",
  cpp: "C++",
  scala: "Scala",
  csharp: "C#",
  ocaml: "OCaml",
  nix: "Nix",
  json: "JSON",
  yaml: "YAML",
  html: "HTML",
  java: "Java",
  fstar: "F*",
  css: "CSS",
} as const;

export type TargetLanguage =
  | "TypeScript"
  | "Haskell"
  | "SQLite"
  | "PostgreSQL"
  | "Bash"
  | "Rust"
  | "Elixir"
  | "Python"
  | "C++"
  | "Scala"
  | "C#"
  | "OCaml"
  | "Nix"
  | "JSON"
  | "YAML"
  | "HTML"
  | "Java"
  | "F*"
  | "CSS";


export const ForeignKeyAction = {
  cascade: "cascade",
  restrict: "restrict",
  set_null: "setNull",
  set_default: "setDefault",
  no_action: "noAction",
} as const;

export type ForeignKeyAction =
  | "cascade"
  | "restrict"
  | "setNull"
  | "setDefault"
  | "noAction";


export const IndexType = {
  primary: "primary",
  unique: "unique",
  indexed: "indexed",
  none: "none",
} as const;

export type IndexType =
  | "primary"
  | "unique"
  | "indexed"
  | "none";


export const SQLDefault = {
  none: "none",
  auto_increment: "autoIncrement",
  current_time: "currentTime",
  value: "value",
} as const;

export type SQLDefault =
  | "none"
  | "autoIncrement"
  | "currentTime"
  | "value";


export const PortType = {
  well_known: "wellKnown",
  registered: "registered",
  ephemeral: "ephemeral",
} as const;

export type PortType =
  | "wellKnown"
  | "registered"
  | "ephemeral";


export const CRUD = {
  create: "create",
  read: "read",
  update: "update",
  delete: "delete",
  list: "list",
} as const;

export type CRUD =
  | "create"
  | "read"
  | "update"
  | "delete"
  | "list";


export const TypeInstance = {
  ti_instance: "tiInstance",
  ti_primitive: "tiPrimitive",
  ti_set: "tiSet",
  ti_array: "tiArray",
  ti_type: "tiType",
  ti_function: "tiFunction",
  ti_optional: "tiOptional",
  ti_var: "tiVar",
  ti_app: "tiApp",
  ti_parens: "tiParens",
  ti_map: "tiMap",
} as const;

export type TypeInstance =
  | "tiInstance"
  | "tiPrimitive"
  | "tiSet"
  | "tiArray"
  | "tiType"
  | "tiFunction"
  | "tiOptional"
  | "tiVar"
  | "tiApp"
  | "tiParens"
  | "tiMap";


export const TermInstance = {
  tm_type: "tmType",
  tm_tag: "tmTag",
  tm_prim: "tmPrim",
  tm_set: "tmSet",
  tm_set_saturated: "tmSetSaturated",
  tm_array: "tmArray",
  tm_array_saturated: "tmArraySaturated",
  tm_map: "tmMap",
  tm_product_lit: "tmProductLit",
} as const;

export type TermInstance =
  | "tmType"
  | "tmTag"
  | "tmPrim"
  | "tmSet"
  | "tmSetSaturated"
  | "tmArray"
  | "tmArraySaturated"
  | "tmMap"
  | "tmProductLit";


export const PrimitiveTerm = {
  pt_integer: "ptInteger",
  pt_char: "ptChar",
  pt_text: "ptText",
  pt_boolean: "ptBoolean",
  pt_unit: "ptUnit",
  pt_double: "ptDouble",
} as const;

export type PrimitiveTerm =
  | "ptInteger"
  | "ptChar"
  | "ptText"
  | "ptBoolean"
  | "ptUnit"
  | "ptDouble";


export const Kind = {
  k_star: "kStar",
  k_arrow: "kArrow",
} as const;

export type Kind =
  | "kStar"
  | "kArrow";


export const Primitive = {
  p_integer: "pInteger",
  p_char: "pChar",
  p_text: "pText",
  p_boolean: "pBoolean",
  p_unit: "pUnit",
  p_double: "pDouble",
} as const;

export type Primitive =
  | "pInteger"
  | "pChar"
  | "pText"
  | "pBoolean"
  | "pUnit"
  | "pDouble";


export const CasePattern = {
  cp_tag: "cpTag",
  cp_prim: "cpPrim",
  cp_array: "cpArray",
  cp_set: "cpSet",
} as const;

export type CasePattern =
  | "cpTag"
  | "cpPrim"
  | "cpArray"
  | "cpSet";


export const MatrixSection = {
  m_xaxis: "mXaxis",
  m_yaxis: "mYaxis",
  m_body: "mBody",
} as const;

export type MatrixSection =
  | "mXaxis"
  | "mYaxis"
  | "mBody";


export const InstanceTarget = {
  target_type: "targetType",
  target_partial_app: "targetPartialApp",
} as const;

export type InstanceTarget =
  | "targetType"
  | "targetPartialApp";


export const ThemePushEvent = {
  apply_theme: "apply_theme",
  apply_font: "apply_font",
  apply_custom_palette: "apply_custom_palette",
  clear_custom_palette: "clear_custom_palette",
} as const;

export type ThemePushEvent =
  | "apply_theme"
  | "apply_font"
  | "apply_custom_palette"
  | "clear_custom_palette";


export const ThemeHook = {
  theme_apply: "ThemeApply",
} as const;

export type ThemeHook =
  | "ThemeApply";


export const SshElementId = {
  ssh_key_form: "sshKeyForm",
  ssh_key_paste_zone: "sshKeyPasteZone",
  ssh_key_public_key: "sshKeyPublicKey",
  ssh_key_name: "sshKeyName",
  ssh_key_expires_at: "sshKeyExpiresAt",
  key_feedback: "keyFeedback",
  copy_preview_fp: "copyPreviewFp",
} as const;

export type SshElementId =
  | "sshKeyForm"
  | "sshKeyPasteZone"
  | "sshKeyPublicKey"
  | "sshKeyName"
  | "sshKeyExpiresAt"
  | "keyFeedback"
  | "copyPreviewFp";


export const SshHook = {
  ssh_key_paste: "SshKeyPaste",
} as const;

export type SshHook =
  | "SshKeyPaste";


export const RepoElementId = {
  http_url: "httpUrl",
  ssh_url: "sshUrl",
  delete_subgroup_modal: "deleteSubgroupModal",
  move_group_modal: "moveGroupModal",
} as const;

export type RepoElementId =
  | "httpUrl"
  | "sshUrl"
  | "deleteSubgroupModal"
  | "moveGroupModal";


export const ProfileElementId = {
  dashboard_content: "dashboardContent",
  activity_viz: "activityViz",
  avatar_upload_modal: "avatarUploadModal",
} as const;

export type ProfileElementId =
  | "dashboardContent"
  | "activityViz"
  | "avatarUploadModal";


export const ProfileHook = {
  profile_identity: "ProfileIdentity",
  profile_about: "ProfileAbout",
  project_stories: "ProjectStories",
  activity_viz: "ActivityViz",
  engagement: "Engagement",
  contrib_terrain: "ContribTerrain",
  obsidian_bg: "ObsidianBg",
} as const;

export type ProfileHook =
  | "ProfileIdentity"
  | "ProfileAbout"
  | "ProjectStories"
  | "ActivityViz"
  | "Engagement"
  | "ContribTerrain"
  | "ObsidianBg";


export const PrPushEvent = {
  focus_next_unresolved: "focus_next_unresolved",
  start_reply: "start_reply",
  start_edit_comment: "start_edit_comment",
  save_inline_comment: "save_inline_comment",
} as const;

export type PrPushEvent =
  | "focus_next_unresolved"
  | "start_reply"
  | "start_edit_comment"
  | "save_inline_comment";


export const PrElementId = {
  pr_title: "prTitle",
  pr_body: "prBody",
  pr_body_editor: "prBodyEditor",
  edit_pr_body_editor: "editPrBodyEditor",
  edit_pr_body: "editPrBody",
  pr_diff: "prDiff",
  pr_timeline: "prTimeline",
  pr_timeline_inner: "prTimelineInner",
  pr_timeline_line: "prTimelineLine",
  pr_comment_body: "prCommentBody",
  reply_submit: "replySubmit",
  edit_comment_submit: "editCommentSubmit",
} as const;

export type PrElementId =
  | "prTitle"
  | "prBody"
  | "prBodyEditor"
  | "editPrBodyEditor"
  | "editPrBody"
  | "prDiff"
  | "prTimeline"
  | "prTimelineInner"
  | "prTimelineLine"
  | "prCommentBody"
  | "replySubmit"
  | "editCommentSubmit";


export const PrHook = {
  pr_timeline: "PrTimeline",
  inline_comment_form: "InlineCommentForm",
  diff_lazy_load: "DiffLazyLoad",
} as const;

export type PrHook =
  | "PrTimeline"
  | "InlineCommentForm"
  | "DiffLazyLoad";


export const OmnisearchCategory = {
  nav: "nav",
  repo: "repo",
  issue: "issue",
  pr: "pr",
  lane: "lane",
  user: "user",
  group: "group",
} as const;

export type OmnisearchCategory =
  | "nav"
  | "repo"
  | "issue"
  | "pr"
  | "lane"
  | "user"
  | "group";


export const SearchPushEvent = {
  search_data: "search_data",
  file_suggestions: "file_suggestions",
  autocomplete_files: "autocomplete_files",
} as const;

export type SearchPushEvent =
  | "search_data"
  | "file_suggestions"
  | "autocomplete_files";


export const OmnisearchPushEvent = {
  omnisearch_toggle: "omnisearch_toggle",
  omnisearch_navigate: "omnisearch_navigate",
  omnisearch_close: "omnisearch_close",
} as const;

export type OmnisearchPushEvent =
  | "omnisearch_toggle"
  | "omnisearch_navigate"
  | "omnisearch_close";


export const OmnisearchElementId = {
  omnisearch_trigger: "omnisearchTrigger",
  omnisearch_modal: "omnisearchModal",
  omnisearch_tabs: "omnisearchTabs",
  omnisearch_results: "omnisearchResults",
} as const;

export type OmnisearchElementId =
  | "omnisearchTrigger"
  | "omnisearchModal"
  | "omnisearchTabs"
  | "omnisearchResults";


export const OmnisearchHook = {
  omni_search: "OmniSearch",
  omni_search_trigger: "OmniSearchTrigger",
} as const;

export type OmnisearchHook =
  | "OmniSearch"
  | "OmniSearchTrigger";


export const LocalStorageKey = {
  blame_width: "blame-width",
  editor_vim_mode: "editor-vim-mode",
  sidebar_w: "sidebar_w",
  job_detail_w: "job_detail_w",
  diff_commit_panel_w: "diff_commit_panel_w",
  workspace_panel_w: "workspace_panel_w",
} as const;

export type LocalStorageKey =
  | "blame-width"
  | "editor-vim-mode"
  | "sidebar_w"
  | "job_detail_w"
  | "diff_commit_panel_w"
  | "workspace_panel_w";


export const EditorPushEvent = {
  set_code: "set_code",
  set_blame: "set_blame",
  clear_blame: "clear_blame",
  set_comments: "set_comments",
  open_sidebar: "open_sidebar",
  scroll_to: "scroll_to",
  toggle_blame: "toggle_blame",
  set_editor_mode: "set_editor_mode",
  toggle_sidebar: "toggle_sidebar",
  permalink: "permalink",
  select_commits: "select_commits",
  clear_editor: "clear_editor",
  save_file: "save_file",
  file_saved: "file_saved",
  commit_changes: "commit_changes",
  commit_success: "commit_success",
  lsp_ready: "lsp_ready",
  lsp_stop: "lsp_stop",
  fetch_history_content: "fetch_history_content",
  history_content: "history_content",
  start_comment: "start_comment",
  cancel_comment: "cancel_comment",
  save_comment: "save_comment",
  reply_comment: "reply_comment",
  edit_comment: "edit_comment",
  cancel_comment_edit: "cancel_comment_edit",
  update_comment: "update_comment",
  delete_line_comment: "delete_line_comment",
  select_workspace_shell: "select_workspace_shell",
  terminate_workspace: "terminate_workspace",
  toggle_workspace_panel: "toggle_workspace_panel",
  workspace_file_changed: "workspace_file_changed",
} as const;

export type EditorPushEvent =
  | "set_code"
  | "set_blame"
  | "clear_blame"
  | "set_comments"
  | "open_sidebar"
  | "scroll_to"
  | "toggle_blame"
  | "set_editor_mode"
  | "toggle_sidebar"
  | "permalink"
  | "select_commits"
  | "clear_editor"
  | "save_file"
  | "file_saved"
  | "commit_changes"
  | "commit_success"
  | "lsp_ready"
  | "lsp_stop"
  | "fetch_history_content"
  | "history_content"
  | "start_comment"
  | "cancel_comment"
  | "save_comment"
  | "reply_comment"
  | "edit_comment"
  | "cancel_comment_edit"
  | "update_comment"
  | "delete_line_comment"
  | "select_workspace_shell"
  | "terminate_workspace"
  | "toggle_workspace_panel"
  | "workspace_file_changed";


export const EditorElementId = {
  readme_content: "readmeContent",
  code_editor_layout: "codeEditorLayout",
  shortcuts_overlay: "shortcutsOverlay",
  outline_panel: "outlinePanel",
  pane_divider: "paneDivider",
  history_viewer: "historyViewer",
  history_scroll: "historyScroll",
  vim_toggle: "vimToggle",
  easymde_toggle: "easymdeToggle",
  rendered_toggle: "renderedToggle",
  easymde_container: "easymdeContainer",
  rich_editor: "richEditor",
  rendered_content: "renderedContent",
  code_viewer: "codeViewer",
  comments_panel: "commentsPanel",
  comment_draft_form: "commentDraftForm",
  workspace_panel: "workspacePanel",
  workspace_terminal: "workspaceTerminal",
  workspace_shell_select: "workspaceShellSelect",
  workspace_shell_form: "workspaceShellForm",
  workspace_fullscreen_toggle: "workspaceFullscreenToggle",
  workspace_panel_divider: "workspacePanelDivider",
  workspace_panel_toggle: "workspacePanelToggle",
} as const;

export type EditorElementId =
  | "readmeContent"
  | "codeEditorLayout"
  | "shortcutsOverlay"
  | "outlinePanel"
  | "paneDivider"
  | "historyViewer"
  | "historyScroll"
  | "vimToggle"
  | "easymdeToggle"
  | "renderedToggle"
  | "easymdeContainer"
  | "richEditor"
  | "renderedContent"
  | "codeViewer"
  | "commentsPanel"
  | "commentDraftForm"
  | "workspacePanel"
  | "workspaceTerminal"
  | "workspaceShellSelect"
  | "workspaceShellForm"
  | "workspaceFullscreenToggle"
  | "workspacePanelDivider"
  | "workspacePanelToggle";


export const EditorHook = {
  code_editor: "CodeEditor",
  history_viewer: "HistoryViewer",
  readme_highlight: "ReadmeHighlight",
  diff_highlight: "DiffHighlight",
  diff_inline_wrap: "DiffInlineWrap",
  diff_comment_btn: "DiffCommentBtn",
  code_ref_autocomplete: "CodeRefAutocomplete",
  markdown_editor: "MarkdownEditor",
  vim_toggle: "VimToggle",
  editor_mode_button: "EditorModeButton",
  pane_divider: "PaneDivider",
  scroll_preserve: "ScrollPreserve",
  workspace_terminal: "WorkspaceTerminal",
  comment_anchor: "CommentAnchor",
} as const;

export type EditorHook =
  | "CodeEditor"
  | "HistoryViewer"
  | "ReadmeHighlight"
  | "DiffHighlight"
  | "DiffInlineWrap"
  | "DiffCommentBtn"
  | "CodeRefAutocomplete"
  | "MarkdownEditor"
  | "VimToggle"
  | "EditorModeButton"
  | "PaneDivider"
  | "ScrollPreserve"
  | "WorkspaceTerminal"
  | "CommentAnchor";


export const EditorAction = {
  to_source: "toSource",
  to_vim: "toVim",
  to_rich: "toRich",
  to_rendered: "toRendered",
} as const;

export type EditorAction =
  | "toSource"
  | "toVim"
  | "toRich"
  | "toRendered";


export const EditorMode = {
  source: "Source",
  vim: "Vim",
  rich: "Rich",
  rendered: "Rendered",
} as const;

export type EditorMode =
  | "Source"
  | "Vim"
  | "Rich"
  | "Rendered";


export const CssClassProfile = {
  profile_avatar: "profile-avatar",
  profile_name: "profile-name",
  profile_meta: "profile-meta",
  profile_socials: "profile-socials",
} as const;

export type CssClassProfile =
  | "profile-avatar"
  | "profile-name"
  | "profile-meta"
  | "profile-socials";


export const CssClassModal = {
  modal_panel: "modal-panel",
  modal_backdrop: "modal-backdrop",
  awaiting_gsap: "awaiting-gsap",
  fade_out: "fade-out",
  app_shell: "app-shell",
} as const;

export type CssClassModal =
  | "modal-panel"
  | "modal-backdrop"
  | "awaiting-gsap"
  | "fade-out"
  | "app-shell";


export const CssClassCodeBrowser = {
  blame_active: "blame-active",
  blame_divider: "blame-divider",
  cm_blame_gutter: "cm-blame-gutter",
  cm_blame_annotation: "cm-blame-annotation",
  cm_commented_line: "cm-commented-line",
  cm_highlighted_line: "cm-highlighted-line",
  code_sidebar: "code-sidebar",
  code_editor_layout: "code-editor-layout",
  dragging: "dragging",
  resizing: "resizing",
  sidebar_hidden: "sidebar-hidden",
  sidebar_close_btn: "sidebar-close-btn",
  workspace_terminal_fullscreen: "workspace-terminal-fullscreen",
} as const;

export type CssClassCodeBrowser =
  | "blame-active"
  | "blame-divider"
  | "cm-blame-gutter"
  | "cm-blame-annotation"
  | "cm-commented-line"
  | "cm-highlighted-line"
  | "code-sidebar"
  | "code-editor-layout"
  | "dragging"
  | "resizing"
  | "sidebar-hidden"
  | "sidebar-close-btn"
  | "workspace-terminal-fullscreen";


export const CssClassDiff = {
  diff_comment_btn: "diff-comment-btn",
  diff_comment_btn_reply: "diff-comment-btn-reply",
  diff_inline_wrap: "diff-inline-wrap",
  diff_inline_cell: "diff-inline-cell",
  diff_inline_form_client: "diff-inline-form-client",
  inline_comment_form: "inline-comment-form",
} as const;

export type CssClassDiff =
  | "diff-comment-btn"
  | "diff-comment-btn-reply"
  | "diff-inline-wrap"
  | "diff-inline-cell"
  | "diff-inline-form-client"
  | "inline-comment-form";


export const CiPushEvent = {
  sparkline_update: "sparkline:update",
  graph_update: "graph:update",
  graph_state: "graph:state",
  build_log_line: "build_log:line",
  build_log_clear: "build_log:clear",
  build_log_load: "build_log:load",
  builder_started: "builder_started",
  job_select: "job:select",
  job_deselect: "job:deselect",
  attempt_select: "attempt:select",
  job_metrics_sample: "job_metrics:sample",
  job_metrics_load: "job_metrics:load",
  runner_metrics_sample: "runner_metrics:sample",
  runner_metrics_load: "runner_metrics:load",
  session_metrics_sample: "session_metrics:sample",
  eval_log_line: "eval_log_line",
  eval_log_clear: "eval_log_clear",
} as const;

export type CiPushEvent =
  | "sparkline:update"
  | "graph:update"
  | "graph:state"
  | "build_log:line"
  | "build_log:clear"
  | "build_log:load"
  | "builder_started"
  | "job:select"
  | "job:deselect"
  | "attempt:select"
  | "job_metrics:sample"
  | "job_metrics:load"
  | "runner_metrics:sample"
  | "runner_metrics:load"
  | "session_metrics:sample"
  | "eval_log_line"
  | "eval_log_clear";


export const CiElementId = {
  pipeline_health: "pipelineHealth",
  pipeline_sparklines: "pipelineSparklines",
  pipeline_list: "pipelineList",
  pipeline_graph: "pipelineGraph",
  pipeline_graph_canvas: "pipelineGraphCanvas",
  job_detail_panel: "jobDetailPanel",
  build_log_terminal: "buildLogTerminal",
  build_log_search: "buildLogSearch",
  build_log_fullscreen: "buildLogFullscreen",
  build_log_jump_bottom: "buildLogJumpBottom",
  eval_detail_panel: "evalDetailPanel",
  flake_inputs_panel: "flakeInputsPanel",
  pipeline_filter_bar: "pipelineFilterBar",
  job_filter_system: "jobFilterSystem",
  job_filter_status: "jobFilterStatus",
  job_filter_search: "jobFilterSearch",
  follow_mode_toggle: "followModeToggle",
  pipeline_retry_btn: "pipelineRetryBtn",
  pipeline_cancel_btn: "pipelineCancelBtn",
} as const;

export type CiElementId =
  | "pipelineHealth"
  | "pipelineSparklines"
  | "pipelineList"
  | "pipelineGraph"
  | "pipelineGraphCanvas"
  | "jobDetailPanel"
  | "buildLogTerminal"
  | "buildLogSearch"
  | "buildLogFullscreen"
  | "buildLogJumpBottom"
  | "evalDetailPanel"
  | "flakeInputsPanel"
  | "pipelineFilterBar"
  | "jobFilterSystem"
  | "jobFilterStatus"
  | "jobFilterSearch"
  | "followModeToggle"
  | "pipelineRetryBtn"
  | "pipelineCancelBtn";


export const DataAttr = {
  job_id: "jobId",
  runner_id: "runnerId",
  session_id: "sessionId",
  cores: "cores",
  ram_bytes: "ramBytes",
  initial_samples: "initialSamples",
  status_filter: "statusFilter",
  chart_type: "type",
  color: "color",
  unit: "unit",
  event_key: "eventKey",
  estimated_ms: "estimatedMs",
  build_started_at: "buildStartedAt",
  streaming: "streaming",
  all_hashes: "allHashes",
  selected: "selected",
  history_waypoint: "historyWaypoint",
  row_selector: "rowSelector",
  arm_root_selector: "armRootSelector",
  arm_change_selector: "armChangeSelector",
  editor_mode: "editorMode",
} as const;

export type DataAttr =
  | "jobId"
  | "runnerId"
  | "sessionId"
  | "cores"
  | "ramBytes"
  | "initialSamples"
  | "statusFilter"
  | "type"
  | "color"
  | "unit"
  | "eventKey"
  | "estimatedMs"
  | "buildStartedAt"
  | "streaming"
  | "allHashes"
  | "selected"
  | "historyWaypoint"
  | "rowSelector"
  | "armRootSelector"
  | "armChangeSelector"
  | "editorMode";


export const Surface = {
  canvas: "canvas",
  svg: "svg",
} as const;

export type Surface =
  | "canvas"
  | "svg";


export const CiHook = {
  dag_graph: "DagGraph",
  build_log: "BuildLog",
  eval_log: "EvalLog",
  sparkline: "Sparkline",
  ci_animations: "CiAnimations",
  kde_chart: "KdeChart",
  scatter_plot: "ScatterPlot",
  job_detail_panel: "JobDetailPanel",
  pipeline_favicon: "PipelineFavicon",
  job_metrics_chart: "JobMetricsChart",
  runner_metrics_chart: "RunnerMetricsChart",
  session_metrics_chart: "SessionMetricsChart",
  live_duration: "LiveDuration",
  recent_commits: "RecentCommits",
  commit_select: "CommitSelect",
} as const;

export type CiHook =
  | "DagGraph"
  | "BuildLog"
  | "EvalLog"
  | "Sparkline"
  | "CiAnimations"
  | "KdeChart"
  | "ScatterPlot"
  | "JobDetailPanel"
  | "PipelineFavicon"
  | "JobMetricsChart"
  | "RunnerMetricsChart"
  | "SessionMetricsChart"
  | "LiveDuration"
  | "RecentCommits"
  | "CommitSelect";


export const SortDir = {
  asc: "asc",
  desc: "desc",
} as const;

export type SortDir =
  | "asc"
  | "desc";


export const ModalCloseEvent = {
  cancel_avatar: "cancel_avatar",
  cancel_editing: "cancel_editing",
  close_attach_env_host_modal: "close_attach_env_host_modal",
  close_attach_runner_modal: "close_attach_runner_modal",
  close_delete_subgroup_modal: "close_delete_subgroup_modal",
  close_group_details_modal: "close_group_details_modal",
  close_invite_modal: "close_invite_modal",
  close_move_group_modal: "close_move_group_modal",
  close_move_repo_modal: "close_move_repo_modal",
  close_move_repos_modal: "close_move_repos_modal",
  close_new_group_modal: "close_new_group_modal",
  close_new_lane_modal: "close_new_lane_modal",
  close_new_pr_modal: "close_new_pr_modal",
  close_new_repo_modal: "close_new_repo_modal",
  close_pb_modal: "close_pb_modal",
  close_pt_modal: "close_pt_modal",
  close_subgroup_modal: "close_subgroup_modal",
  close_workspace_picker_modal: "close_workspace_picker_modal",
  toggle_clone: "toggle_clone",
  toggle_fork: "toggle_fork",
} as const;

export type ModalCloseEvent =
  | "cancel_avatar"
  | "cancel_editing"
  | "close_attach_env_host_modal"
  | "close_attach_runner_modal"
  | "close_delete_subgroup_modal"
  | "close_group_details_modal"
  | "close_invite_modal"
  | "close_move_group_modal"
  | "close_move_repo_modal"
  | "close_move_repos_modal"
  | "close_new_group_modal"
  | "close_new_lane_modal"
  | "close_new_pr_modal"
  | "close_new_repo_modal"
  | "close_pb_modal"
  | "close_pt_modal"
  | "close_subgroup_modal"
  | "close_workspace_picker_modal"
  | "toggle_clone"
  | "toggle_fork";


export const CookieKey = {
  view_tab: "view_tab",
} as const;

export type CookieKey =
  | "view_tab";


export const DomEvent = {
  phx_copy: "phx:copy",
  phx_set_view_tab: "phx:set-view-tab",
  phx_toast: "phx:toast",
  phx_server_draining: "phx:server-draining",
  phx_save_file: "phx:save-file",
  phx_editor_document: "phx:editor-document",
} as const;

export type DomEvent =
  | "phx:copy"
  | "phx:set-view-tab"
  | "phx:toast"
  | "phx:server-draining"
  | "phx:save-file"
  | "phx:editor-document";


export const ChannelEvent = {
  log_line: "log:line",
  log_chunk: "log:chunk",
  job_status: "job:status",
} as const;

export type ChannelEvent =
  | "log:line"
  | "log:chunk"
  | "job:status";


export const ToastKind = {
  info: "info",
  warning: "warning",
  error: "error",
} as const;

export type ToastKind =
  | "info"
  | "warning"
  | "error";


export const ToastElementId = {
  toast_container: "toastContainer",
  toast_info: "toastInfo",
  toast_error: "toastError",
} as const;

export type ToastElementId =
  | "toastContainer"
  | "toastInfo"
  | "toastError";


export const BranchSelectPushEvent = {
  branch_select_toggle: "branch_select_toggle",
  branch_select_data: "branch_select_data",
  branch_select_choose: "branch_select_choose",
  branch_lane_create: "branch_lane_create",
} as const;

export type BranchSelectPushEvent =
  | "branch_select_toggle"
  | "branch_select_data"
  | "branch_select_choose"
  | "branch_lane_create";


export const UiHook = {
  modal: "Modal",
  toast: "Toast",
  dropdown: "Dropdown",
  clipboard: "Clipboard",
  table_sort_animate: "TableSortAnimate",
  details_fold: "DetailsFold",
  keyboard_shortcuts: "KeyboardShortcuts",
  row_expander: "RowExpander",
  commit_panel_toggle: "CommitPanelToggle",
  file_expander: "FileExpander",
  delete_confirm_gate: "DeleteConfirmGate",
  workspaces_nav_toggle: "WorkspacesNavToggle",
  client_table_sort: "ClientTableSort",
  client_list_filter: "ClientListFilter",
  disclosure_toggle: "DisclosureToggle",
  section_toggle: "SectionToggle",
  profile_dropdown: "ProfileDropdown",
  branch_select: "BranchSelect",
} as const;

export type UiHook =
  | "Modal"
  | "Toast"
  | "Dropdown"
  | "Clipboard"
  | "TableSortAnimate"
  | "DetailsFold"
  | "KeyboardShortcuts"
  | "RowExpander"
  | "CommitPanelToggle"
  | "FileExpander"
  | "DeleteConfirmGate"
  | "WorkspacesNavToggle"
  | "ClientTableSort"
  | "ClientListFilter"
  | "DisclosureToggle"
  | "SectionToggle"
  | "ProfileDropdown"
  | "BranchSelect";


export const AuthElementId = {
  auth_email: "authEmail",
  auth_password: "authPassword",
  auth_username: "authUsername",
  auth_display_name: "authDisplayName",
  auth_error: "authError",
  auth_submit: "authSubmit",
} as const;

export type AuthElementId =
  | "authEmail"
  | "authPassword"
  | "authUsername"
  | "authDisplayName"
  | "authError"
  | "authSubmit";


export const AuthHook = {
  auth_error: "AuthError",
  auth_card: "AuthCard",
} as const;

export type AuthHook =
  | "AuthError"
  | "AuthCard";


export const PreflightReason = {
  missing_dox_dir: "Missing .dox/ directory",
  missing_artefact: "Missing required artefact under .dox/",
  no_source_files: "No .dox source files found under domain/",
  stale: "Stale codegen — source newer than artefact",
  unreadable_artefact: "Could not read mtime of any required artefact",
} as const;

export type PreflightReason =
  | "Missing .dox/ directory"
  | "Missing required artefact under .dox/"
  | "No .dox source files found under domain/"
  | "Stale codegen — source newer than artefact"
  | "Could not read mtime of any required artefact";


export const AdvancedColorMode = {
  derived: "Derived values",
  custom: "Custom values",
} as const;

export type AdvancedColorMode =
  | "Derived values"
  | "Custom values";


export const Font = {
  dejavu_mono: "DejaVu Mono",
  jetbrains_mono: "JetBrains Mono",
  fira_code: "Fira Code",
  ibm_plex_mono: "IBM Plex Mono",
  iosevka: "Iosevka",
  cascadia_code: "Cascadia Code",
  hack: "Hack",
  source_code_pro: "Source Code Pro",
} as const;

export type Font =
  | "DejaVu Mono"
  | "JetBrains Mono"
  | "Fira Code"
  | "IBM Plex Mono"
  | "Iosevka"
  | "Cascadia Code"
  | "Hack"
  | "Source Code Pro";


export const Theme = {
  custom_dark: "Custom Dark",
  custom_light: "Custom Light",
  abcdef: "Abcdef",
  abyss: "Abyss",
  android_studio: "Android Studio",
  andromeda: "Andromeda",
  basic_dark: "Basic Dark",
  basic_light: "Basic Light",
  catppuccin_mocha: "Catppuccin Mocha",
  cobalt2: "Cobalt2",
  forest: "Forest",
  github_dark: "Github Dark",
  github_light: "Github Light",
  gruvbox_dark: "Gruvbox Dark",
  gruvbox_light: "Gruvbox Light",
  high_contrast_dark: "High Contrast Dark",
  high_contrast_light: "High Contrast Light",
  material_dark: "Material Dark",
  material_light: "Material Light",
  material_ocean: "Material Ocean",
  monokai: "Monokai",
  nord: "Nord",
  palenight: "Palenight",
  solarized_dark: "Solarized Dark",
  solarized_light: "Solarized Light",
  synthwave84: "Synthwave 84",
  tokyo_night_day: "Tokyo Night Day",
  tokyo_night_storm: "Tokyo Night Storm",
  volcano: "Volcano",
  vscode_dark: "Vscode Dark",
  vscode_light: "Vscode Light",
} as const;

export type Theme =
  | "Custom Dark"
  | "Custom Light"
  | "Abcdef"
  | "Abyss"
  | "Android Studio"
  | "Andromeda"
  | "Basic Dark"
  | "Basic Light"
  | "Catppuccin Mocha"
  | "Cobalt2"
  | "Forest"
  | "Github Dark"
  | "Github Light"
  | "Gruvbox Dark"
  | "Gruvbox Light"
  | "High Contrast Dark"
  | "High Contrast Light"
  | "Material Dark"
  | "Material Light"
  | "Material Ocean"
  | "Monokai"
  | "Nord"
  | "Palenight"
  | "Solarized Dark"
  | "Solarized Light"
  | "Synthwave 84"
  | "Tokyo Night Day"
  | "Tokyo Night Storm"
  | "Volcano"
  | "Vscode Dark"
  | "Vscode Light";


export const SecretScope = {
  group: "Group",
  repo: "Repo",
} as const;

export type SecretScope =
  | "Group"
  | "Repo";


export const SecretKind = {
  ssh_key: "SSH key",
  env_var: "Environment variable",
  file: "File",
} as const;

export type SecretKind =
  | "SSH key"
  | "Environment variable"
  | "File";


export const EnvVar = {
  internal_push: "OPERATION_INTERNAL_PUSH",
  runner_keys_file: "OPERATION_RUNNER_KEYS_FILE",
  runner_sk: "OPERATION_RUNNER_SK",
  runner_pk: "OPERATION_RUNNER_PK",
  runner_caps_timeout_ms: "OPERATION_RUNNER_CAPS_TIMEOUT_MS",
  secrets_key_file: "OPERATION_SECRETS_KEY_FILE",
  ssh_host_keys_dir: "OPERATION_SSH_HOST_KEYS_DIR",
  test_db: "OPERATION_TEST_DB",
  bandit_pool_size: "OPERATION_BANDIT_POOL_SIZE",
  node_count: "OPERATION_NODE_COUNT",
  drain_ms: "OPERATION_DRAIN_MS",
  git_ssh_endpoint: "OPERATION_GIT_SSH_ENDPOINT",
} as const;

export type EnvVar =
  | "OPERATION_INTERNAL_PUSH"
  | "OPERATION_RUNNER_KEYS_FILE"
  | "OPERATION_RUNNER_SK"
  | "OPERATION_RUNNER_PK"
  | "OPERATION_RUNNER_CAPS_TIMEOUT_MS"
  | "OPERATION_SECRETS_KEY_FILE"
  | "OPERATION_SSH_HOST_KEYS_DIR"
  | "OPERATION_TEST_DB"
  | "OPERATION_BANDIT_POOL_SIZE"
  | "OPERATION_NODE_COUNT"
  | "OPERATION_DRAIN_MS"
  | "OPERATION_GIT_SSH_ENDPOINT";


export const GroupMembershipEvent = {
  accept_invitation: "acceptInvitation",
  decline_invitation: "declineInvitation",
  revoke_invitation: "revokeInvitation",
} as const;

export type GroupMembershipEvent =
  | "acceptInvitation"
  | "declineInvitation"
  | "revokeInvitation";


export const GroupMembershipStatus = {
  invited: "invited",
  accepted: "accepted",
  closed: "closed",
} as const;

export type GroupMembershipStatus =
  | "invited"
  | "accepted"
  | "closed";


export const AdminEventKind = {
  revoke_host: "Revoke Host",
  rotate_group_token: "Rotate Group Token",
  pin_dispatch: "Pin Dispatch",
  change_policy: "Change Policy",
  revoke_session: "Revoke Session",
  force_terminate: "Force Terminate",
} as const;

export type AdminEventKind =
  | "Revoke Host"
  | "Rotate Group Token"
  | "Pin Dispatch"
  | "Change Policy"
  | "Revoke Session"
  | "Force Terminate";


export const DevSessionEvent = {
  session_ready: "Session Ready",
  flake_changed: "Flake Changed",
  rebuild_done: "Rebuild Done",
  rebuild_failed: "Rebuild Failed",
  drain: "Drain",
  reconnect: "Reconnect",
  drain_timeout: "Drain Timeout",
  terminate: "Terminate",
} as const;

export type DevSessionEvent =
  | "Session Ready"
  | "Flake Changed"
  | "Rebuild Done"
  | "Rebuild Failed"
  | "Drain"
  | "Reconnect"
  | "Drain Timeout"
  | "Terminate";


export const DevSessionPhase = {
  initializing: "Initializing",
  ready: "Ready",
  rebuilding: "Rebuilding",
  draining: "Draining",
  terminated: "Terminated",
} as const;

export type DevSessionPhase =
  | "Initializing"
  | "Ready"
  | "Rebuilding"
  | "Draining"
  | "Terminated";


export const PermissionLevel = {
  no_one: "No one",
  developers: "Developers",
  maintainers: "Maintainers",
  developers_and_maintainers: "Developers + Maintainers",
} as const;

export type PermissionLevel =
  | "No one"
  | "Developers"
  | "Maintainers"
  | "Developers + Maintainers";


export const SquashSetting = {
  default_squash: "Default",
  do_not_allow: "Do not allow",
  allow_squash: "Allow",
  encourage: "Encourage",
  require_squash: "Require",
} as const;

export type SquashSetting =
  | "Default"
  | "Do not allow"
  | "Allow"
  | "Encourage"
  | "Require";


export const KeyUsage = {
  authentication: "Authentication",
  signing: "Signing",
  auth_and_signing: "Authentication & Signing",
} as const;

export type KeyUsage =
  | "Authentication"
  | "Signing"
  | "Authentication & Signing";


export const Visibility = {
  public: "Public",
  internal: "Internal",
  private: "Private",
} as const;

export type Visibility =
  | "Public"
  | "Internal"
  | "Private";


export const AccessLevel = {
  none: "None",
  read: "Read",
  write: "Write",
  admin: "Admin",
} as const;

export type AccessLevel =
  | "None"
  | "Read"
  | "Write"
  | "Admin";


export const RepoLifecycleEvent = {
  archive_repo: "archiveRepo",
  unarchive_repo: "unarchiveRepo",
  soft_delete_repo: "softDeleteRepo",
  restore_repo: "restoreRepo",
  hard_delete_repo: "hardDeleteRepo",
} as const;

export type RepoLifecycleEvent =
  | "archiveRepo"
  | "unarchiveRepo"
  | "softDeleteRepo"
  | "restoreRepo"
  | "hardDeleteRepo";


export const RepoLifecycle = {
  active: "active",
  archived: "archived",
  pending_deletion: "pendingDeletion",
} as const;

export type RepoLifecycle =
  | "active"
  | "archived"
  | "pendingDeletion";


export const LaneStatusEvent = {
  attach_branch: "attachBranch",
  request_review: "requestReview",
  withdraw_review: "withdrawReview",
  merge_keep_open: "mergeKeepOpen",
  merge_and_close: "mergeAndClose",
  close_lane: "closeLane",
  reopen_lane: "reopenLane",
} as const;

export type LaneStatusEvent =
  | "attachBranch"
  | "requestReview"
  | "withdrawReview"
  | "mergeKeepOpen"
  | "mergeAndClose"
  | "closeLane"
  | "reopenLane";


export const LaneMergeState = {
  pending: "pending",
  landed: "landed",
} as const;

export type LaneMergeState =
  | "pending"
  | "landed";


export const ReactionEmoji = {
  thumbsup: "Thumbs Up",
  thumbsdown: "Thumbs Down",
  heart: "Heart",
  rocket: "Rocket",
  eyes: "Eyes",
  tada: "Celebration",
  confused: "Confused",
} as const;

export type ReactionEmoji =
  | "Thumbs Up"
  | "Thumbs Down"
  | "Heart"
  | "Rocket"
  | "Eyes"
  | "Celebration"
  | "Confused";


export const ReviewVerdict = {
  approve: "Approved",
  request_changes: "Changes Requested",
  comment: "Commented",
} as const;

export type ReviewVerdict =
  | "Approved"
  | "Changes Requested"
  | "Commented";


export const LaneEventKind = {
  branch_attached: "Branch Attached",
  review_requested: "Review Requested",
  review_withdrawn: "Review Withdrawn",
  rebased: "Rebased",
  rebase_failed: "Rebase Failed",
  merged: "Merged",
  closed: "Closed",
  reopened: "Reopened",
  title_edited: "Title Edited",
  description_edited: "Description Edited",
  target_changed: "Target Changed",
  assignee_added: "Assignee Added",
  assignee_removed: "Assignee Removed",
  commits_pushed: "Commits Pushed",
  force_push: "Force Push",
} as const;

export type LaneEventKind =
  | "Branch Attached"
  | "Review Requested"
  | "Review Withdrawn"
  | "Rebased"
  | "Rebase Failed"
  | "Merged"
  | "Closed"
  | "Reopened"
  | "Title Edited"
  | "Description Edited"
  | "Target Changed"
  | "Assignee Added"
  | "Assignee Removed"
  | "Commits Pushed"
  | "Force Push";


export const LaneStatus = {
  idea: "Idea",
  active: "Active",
  in_review: "In Review",
  closed: "Closed",
} as const;

export type LaneStatus =
  | "Idea"
  | "Active"
  | "In Review"
  | "Closed";


export const GridCellKind = {
  review: "review",
  issue: "issue",
  docs: "docs",
  code: "code",
} as const;

export type GridCellKind =
  | "review"
  | "issue"
  | "docs"
  | "code";


export const ProjectStoryStatus = {
  active: "Active",
  archived: "Archived",
  completed: "Completed",
} as const;

export type ProjectStoryStatus =
  | "Active"
  | "Archived"
  | "Completed";


export const SocialPlatform = {
  website: "Website",
  mastodon: "Mastodon",
  linkedin: "LinkedIn",
  blog: "Blog",
  contact_email: "Email",
  github: "GitHub",
  gitlab: "GitLab",
  twitter: "Twitter",
} as const;

export type SocialPlatform =
  | "Website"
  | "Mastodon"
  | "LinkedIn"
  | "Blog"
  | "Email"
  | "GitHub"
  | "GitLab"
  | "Twitter";


export const LanguageExt = {
  bash: "bash",
  beancount: "beancount",
  bibtex: "bibtex",
  c: "c",
  clojure: "clojure",
  cmake: "cmake",
  cpp: "cpp",
  crystal: "crystal",
  csharp: "csharp",
  css: "css",
  cuda: "cuda",
  cue: "cue",
  dart: "dart",
  diff: "diff",
  dockerfile: "dockerfile",
  dot: "dot",
  dox: "dox",
  elisp: "elisp",
  elixir: "elixir",
  elm: "elm",
  erlang: "erlang",
  fennel: "fennel",
  fish: "fish",
  fortran: "fortran",
  fst: "fst",
  gdscript: "gdscript",
  gitignore: "gitignore",
  gleam: "gleam",
  glsl: "glsl",
  go: "go",
  graphql: "graphql",
  haskell: "haskell",
  hcl: "hcl",
  heex: "heex",
  hjson: "hjson",
  html: "html",
  java: "java",
  javascript: "javascript",
  json: "json",
  json5: "json5",
  jsonnet: "jsonnet",
  julia: "julia",
  just: "just",
  kdl: "kdl",
  kotlin: "kotlin",
  latex: "latex",
  ledger: "ledger",
  llvm: "llvm",
  lua: "lua",
  make: "make",
  markdown: "markdown",
  nickel: "nickel",
  nix: "nix",
  nu: "nu",
  ocaml: "ocaml",
  perl: "perl",
  php: "php",
  prisma: "prisma",
  proto: "proto",
  pug: "pug",
  python: "python",
  r: "r",
  rego: "rego",
  rst: "rst",
  ruby: "ruby",
  rust: "rust",
  scala: "scala",
  scheme: "scheme",
  scss: "scss",
  sml: "sml",
  solidity: "solidity",
  sparql: "sparql",
  sql: "sql",
  svelte: "svelte",
  toml: "toml",
  tsx: "tsx",
  turtle: "turtle",
  typescript: "typescript",
  typst: "typst",
  unknown: "unknown",
  verilog: "verilog",
  vim: "vim",
  vue: "vue",
  wgsl: "wgsl",
  yaml: "yaml",
  yang: "yang",
  zig: "zig",
} as const;

export type LanguageExt =
  | "bash"
  | "beancount"
  | "bibtex"
  | "c"
  | "clojure"
  | "cmake"
  | "cpp"
  | "crystal"
  | "csharp"
  | "css"
  | "cuda"
  | "cue"
  | "dart"
  | "diff"
  | "dockerfile"
  | "dot"
  | "dox"
  | "elisp"
  | "elixir"
  | "elm"
  | "erlang"
  | "fennel"
  | "fish"
  | "fortran"
  | "fst"
  | "gdscript"
  | "gitignore"
  | "gleam"
  | "glsl"
  | "go"
  | "graphql"
  | "haskell"
  | "hcl"
  | "heex"
  | "hjson"
  | "html"
  | "java"
  | "javascript"
  | "json"
  | "json5"
  | "jsonnet"
  | "julia"
  | "just"
  | "kdl"
  | "kotlin"
  | "latex"
  | "ledger"
  | "llvm"
  | "lua"
  | "make"
  | "markdown"
  | "nickel"
  | "nix"
  | "nu"
  | "ocaml"
  | "perl"
  | "php"
  | "prisma"
  | "proto"
  | "pug"
  | "python"
  | "r"
  | "rego"
  | "rst"
  | "ruby"
  | "rust"
  | "scala"
  | "scheme"
  | "scss"
  | "sml"
  | "solidity"
  | "sparql"
  | "sql"
  | "svelte"
  | "toml"
  | "tsx"
  | "turtle"
  | "typescript"
  | "typst"
  | "unknown"
  | "verilog"
  | "vim"
  | "vue"
  | "wgsl"
  | "yaml"
  | "yang"
  | "zig";


export const DispatchKind = {
  runner: "Runner",
  env_host: "Env Host",
} as const;

export type DispatchKind =
  | "Runner"
  | "Env Host";


export const EvalStatus = {
  pending: "Pending",
  running: "Running",
  succeeded: "Succeeded",
  failed: "Failed",
} as const;

export type EvalStatus =
  | "Pending"
  | "Running"
  | "Succeeded"
  | "Failed";


export const AttemptStatus = {
  running: "Running",
  succeeded: "Succeeded",
  failed: "Failed",
  timed_out: "Timed Out",
  cancelled: "Cancelled",
} as const;

export type AttemptStatus =
  | "Running"
  | "Succeeded"
  | "Failed"
  | "Timed Out"
  | "Cancelled";


export const NixSystem = {
  amd_linux: "x86_64-linux",
  arm_linux: "aarch64-linux",
  arm_darwin: "aarch64-darwin",
  amd_darwin: "x86_64-darwin",
} as const;

export type NixSystem =
  | "x86_64-linux"
  | "aarch64-linux"
  | "aarch64-darwin"
  | "x86_64-darwin";


export const FlakeOutputInternalType = {
  check: "check",
  package: "package",
  dev_shell: "devShell",
  nixos_configuration: "nixosConfiguration",
  darwin_configuration: "darwinConfiguration",
  hydra_job: "hydraJob",
  custom: "custom",
  app: "app",
  formatter: "formatter",
  template: "template",
  nixos_module: "nixosModule",
} as const;

export type FlakeOutputInternalType =
  | "check"
  | "package"
  | "devShell"
  | "nixosConfiguration"
  | "darwinConfiguration"
  | "hydraJob"
  | "custom"
  | "app"
  | "formatter"
  | "template"
  | "nixosModule";


export const FlakeOutputType = {
  check: "Check",
  package: "Package",
  dev_shell: "Dev Shell",
  nixos_configuration: "NixOS Configuration",
  darwin_configuration: "Darwin Configuration",
  hydra_job: "Hydra Job",
  custom: "Custom",
  app: "App",
  flake_check: "Flake Check",
  dispatch: "Dispatch",
  formatter: "Formatter",
  template: "Template",
  module: "Module",
} as const;

export type FlakeOutputType =
  | "Check"
  | "Package"
  | "Dev Shell"
  | "NixOS Configuration"
  | "Darwin Configuration"
  | "Hydra Job"
  | "Custom"
  | "App"
  | "Flake Check"
  | "Dispatch"
  | "Formatter"
  | "Template"
  | "Module";


export const RetryBackoff = {
  exponential: "Exponential",
  linear: "Linear",
  fixed: "Fixed",
} as const;

export type RetryBackoff =
  | "Exponential"
  | "Linear"
  | "Fixed";


export const FailureClass = {
  build_failure: "Build Failure",
  transient_failure: "Transient Failure",
  evaluation_failure: "Evaluation Failure",
  timeout: "Timeout",
  infrastructure_error: "Infrastructure Error",
  unknown_failure: "Unknown Failure",
} as const;

export type FailureClass =
  | "Build Failure"
  | "Transient Failure"
  | "Evaluation Failure"
  | "Timeout"
  | "Infrastructure Error"
  | "Unknown Failure";


export const PipelineFailureReason = {
  no_runner_for_system: "No runner online for required system",
  no_runner_capable_of_system: "No runner capable of required system",
  no_runner_at_eval_time: "No runner online when evaluation started",
  nix_eval_failed: "Nix eval failed",
  eval_runner_disconnected: "Runner disconnected during evaluation",
} as const;

export type PipelineFailureReason =
  | "No runner online for required system"
  | "No runner capable of required system"
  | "No runner online when evaluation started"
  | "Nix eval failed"
  | "Runner disconnected during evaluation";


export const EvaluationPhase = {
  pending: "Pending",
  evaluation_pending: "Waiting for Runner",
  evaluating: "Evaluating",
  evaluated: "Evaluated",
  eval_failed: "Evaluation Failed",
  cancelled: "Cancelled",
} as const;

export type EvaluationPhase =
  | "Pending"
  | "Waiting for Runner"
  | "Evaluating"
  | "Evaluated"
  | "Evaluation Failed"
  | "Cancelled";


export const JobStatus = {
  queued: "Queued",
  evaluating: "Evaluating",
  preparing: "Preparing",
  building: "Building",
  retrying: "Retrying",
  cached: "Cached",
  succeeded: "Succeeded",
  failed: "Failed",
  cancelled: "Cancelled",
} as const;

export type JobStatus =
  | "Queued"
  | "Evaluating"
  | "Preparing"
  | "Building"
  | "Retrying"
  | "Cached"
  | "Succeeded"
  | "Failed"
  | "Cancelled";


export const PipelineStatus = {
  pending: "Pending",
  evaluation_pending: "Waiting for Runner",
  evaluating: "Evaluating",
  queued: "Queued",
  building: "Building",
  succeeded: "Succeeded",
  failed: "Failed",
  cancelled: "Cancelled",
} as const;

export type PipelineStatus =
  | "Pending"
  | "Waiting for Runner"
  | "Evaluating"
  | "Queued"
  | "Building"
  | "Succeeded"
  | "Failed"
  | "Cancelled";


export const RunnerToServerMsg = {
  hello: "hello",
  auth: "auth",
  capabilities: "capabilities",
  load: "load",
  job_sample: "jobSample",
  host_sample: "hostSample",
  job_accepted: "jobAccepted",
  job_rejected: "jobRejected",
  builder_started: "builderStarted",
  job_exit: "jobExit",
  eval_accepted: "evalAccepted",
  eval_result: "evalResult",
  pong: "pong",
} as const;

export type RunnerToServerMsg =
  | "hello"
  | "auth"
  | "capabilities"
  | "load"
  | "jobSample"
  | "hostSample"
  | "jobAccepted"
  | "jobRejected"
  | "builderStarted"
  | "jobExit"
  | "evalAccepted"
  | "evalResult"
  | "pong";


export const ServerToRunnerMsg = {
  challenge: "challenge",
  job_start: "jobStart",
  job_cancel: "jobCancel",
  eval_start: "evalStart",
  eval_cancel: "evalCancel",
  ping: "ping",
} as const;

export type ServerToRunnerMsg =
  | "challenge"
  | "jobStart"
  | "jobCancel"
  | "evalStart"
  | "evalCancel"
  | "ping";


export const EvalOutcome = {
  success: "success",
  failure: "failure",
} as const;

export type EvalOutcome =
  | "success"
  | "failure";


export const EvalKind = {
  pipeline_eval: "Pipeline eval",
  dispatch_eval: "Dispatch eval",
  app_eval: "App eval",
  module_eval: "Module eval",
  template_eval: "Template eval",
  ref_build: "Ref build",
  flake_check: "Flake check",
} as const;

export type EvalKind =
  | "Pipeline eval"
  | "Dispatch eval"
  | "App eval"
  | "Module eval"
  | "Template eval"
  | "Ref build"
  | "Flake check";


export const DispatchMode = {
  heuristic: "Heuristic",
  bandit: "Bandit",
} as const;

export type DispatchMode =
  | "Heuristic"
  | "Bandit";


export const NixStoreMode = {
  daemon: "daemon",
  chroot: "chroot",
} as const;

export type NixStoreMode =
  | "daemon"
  | "chroot";


export const StreamId = {
  stdout: "stdout",
  stderr: "stderr",
} as const;

export type StreamId =
  | "stdout"
  | "stderr";


export const ScopeMode = {
  system: "system",
  user: "user",
} as const;

export type ScopeMode =
  | "system"
  | "user";


export const JobEvent = {
  start_job_eval: "startJobEval",
  job_eval_done: "jobEvalDone",
  start_build: "startBuild",
  builder_started: "builderStarted",
  build_succeeded: "buildSucceeded",
  build_failed: "buildFailed",
  cache_hit: "cacheHit",
  start_retry: "startRetry",
  cancel_job: "cancelJob",
} as const;

export type JobEvent =
  | "startJobEval"
  | "jobEvalDone"
  | "startBuild"
  | "builderStarted"
  | "buildSucceeded"
  | "buildFailed"
  | "cacheHit"
  | "startRetry"
  | "cancelJob";


export const StatusColorKey = {
  accent: "accent",
  accent_muted: "accentMuted",
  danger: "danger",
  info: "info",
  warning: "warning",
  muted: "muted",
} as const;

export type StatusColorKey =
  | "accent"
  | "accentMuted"
  | "danger"
  | "info"
  | "warning"
  | "muted";


export const StatusColor = {
  green400: "74, 222, 128",
  red400: "248, 113, 113",
  cyan400: "34, 211, 238",
  amber400: "251, 191, 36",
  zinc400: "161, 161, 170",
  zinc500: "113, 113, 122",
} as const;

export type StatusColor =
  | "74, 222, 128"
  | "248, 113, 113"
  | "34, 211, 238"
  | "251, 191, 36"
  | "161, 161, 170"
  | "113, 113, 122";


export const EvaluationEvent = {
  start_eval: "startEval",
  eval_completed: "evalCompleted",
  eval_failed: "evalFailed",
  no_runner: "noRunner",
  cancel: "cancel",
} as const;

export type EvaluationEvent =
  | "startEval"
  | "evalCompleted"
  | "evalFailed"
  | "noRunner"
  | "cancel";


export const EnvHostToServerMsg = {
  hello: "hello",
  auth: "auth",
  capabilities: "capabilities",
  load: "load",
  session_sample: "sessionSample",
  env_accepted: "envAccepted",
  env_rejected: "envRejected",
  env_attach_rejected: "envAttachRejected",
  env_state_changed: "envStateChanged",
  env_exit: "envExit",
  env_dev_shells_ok: "envDevShellsOk",
  env_fs_write_ok: "envFsWriteOk",
  env_fs_read_ok: "envFsReadOk",
  env_git_commit_ok: "envGitCommitOk",
  env_rpc_failed: "envRpcFailed",
  pong: "pong",
} as const;

export type EnvHostToServerMsg =
  | "hello"
  | "auth"
  | "capabilities"
  | "load"
  | "sessionSample"
  | "envAccepted"
  | "envRejected"
  | "envAttachRejected"
  | "envStateChanged"
  | "envExit"
  | "envDevShellsOk"
  | "envFsWriteOk"
  | "envFsReadOk"
  | "envGitCommitOk"
  | "envRpcFailed"
  | "pong";


export const ServerToEnvHostMsg = {
  challenge: "challenge",
  env_start: "envStart",
  env_cancel: "envCancel",
  env_attach: "envAttach",
  env_resize: "envResize",
  env_drain: "envDrain",
  env_list_dev_shells: "envListDevShells",
  env_fs_write: "envFsWrite",
  env_fs_read: "envFsRead",
  env_git_commit: "envGitCommit",
  ping: "ping",
} as const;

export type ServerToEnvHostMsg =
  | "challenge"
  | "envStart"
  | "envCancel"
  | "envAttach"
  | "envResize"
  | "envDrain"
  | "envListDevShells"
  | "envFsWrite"
  | "envFsRead"
  | "envGitCommit"
  | "ping";


export const EnvFsEventKind = {
  created: "created",
  modified: "modified",
  deleted: "deleted",
  moved: "moved",
} as const;

export type EnvFsEventKind =
  | "created"
  | "modified"
  | "deleted"
  | "moved";


export const AuthEvent = {
  signup: "signup",
  login: "login",
  login_failed: "loginFailed",
  logout: "logout",
  unlock: "unlock",
} as const;

export type AuthEvent =
  | "signup"
  | "login"
  | "loginFailed"
  | "logout"
  | "unlock";


export const OidcIconKind = {
  google: "google",
  generic: "generic",
} as const;

export type OidcIconKind =
  | "google"
  | "generic";


export const AuthPhase = {
  anonymous: "anonymous",
  authenticated: "authenticated",
  locked: "locked",
} as const;

export type AuthPhase =
  | "anonymous"
  | "authenticated"
  | "locked";

